import * as types from '../actions/PlanEditorOrdersActionTypes';
import InitialState from './InitialState';
import { assign } from '../../../shared/Assign';

export default function planEditorOrdersReducer(
    state: any = InitialState,
    action: { type: string; result: any }
) {
    let newState: any;

    switch (action.type) {
        case types.GET_PLAN_EDITOR_ORDERS_SUCCESS:
            newState = assign({}, state);
            newState.list = action.result;
            return newState;

        case types.GRAB_PLAN_ORDER_SUCCESS:
            newState = assign({}, state);
            newState.list.forEach((x) => {
                if (x.id === action.result.planOrderId) {
                    x.planEditorId = action.result.userId;
                    x.planEditor = action.result.planEditor;
                }
            });
            return newState;

        case types.EDIT_PLAN_EDITOR_ORDER_SUCCESS:
            newState = assign({}, state);

            newState.edit = action.result;
            newState.list.forEach((x) => {
                if (x.id === action.result.planOrder.id) {
                    x.status = action.result.planOrder.status;
                }
            });

            return newState;

        case types.GET_PLAN_EDITOR_COMPARE_DATA_SUCCESS:
            newState = assign({}, state);
            newState.edit.compareStoreys = action.result;

            return newState;

        case types.ADD_PLAN_ORDER_EXTERNAL_DELIVERY_FILE_SUCCESS:
            newState = assign({}, state);
            newState.edit.planOrder.externalDeliveryFiles = [
                ...newState.edit.planOrder.externalDeliveryFiles,
                assign({}, action.result)
            ];

            if (action.result.oldFileId) {
                newState.edit.planOrder.externalDeliveryFiles = [
                    ...newState.edit.planOrder.externalDeliveryFiles.filter(
                        (x) => x.id !== action.result.oldFileId
                    )
                ];
            }

            if (
                newState.edit.planOrder.delivery &&
                newState.edit.planOrder.delivery.externalDeliveryFiles
            ) {
                newState.edit.planOrder.delivery.externalDeliveryFiles = [
                    ...newState.edit.planOrder.delivery.externalDeliveryFiles,
                    assign({}, action.result)
                ];

                if (action.result.oldFileId) {
                    newState.edit.planOrder.delivery.externalDeliveryFiles = [
                        ...newState.edit.planOrder.delivery.externalDeliveryFiles.filter(
                            (x) =>
                                x.planOrderExternalFileId !== action.result.oldFileId &&
                                x.id !== action.result.oldFileId
                        )
                    ];
                }
            }

            return newState;

        case types.ADD_PLAN_ORDER_INTERNAL_EXTERNAL_FILE_SUCCESS:
            newState = assign({}, state);
            newState.edit.planOrder.internalExternalFiles = [
                ...newState.edit.planOrder.internalExternalFiles,
                assign({}, action.result)
            ];

            if (action.result.oldFileId) {
                newState.edit.planOrder.internalExternalFiles = [
                    ...newState.edit.planOrder.internalExternalFiles.filter(
                        (x) => x.id !== action.result.oldFileId
                    )
                ];
            }

            if (
                newState.edit.planOrder.delivery &&
                newState.edit.planOrder.delivery.internalExternalFiles
            ) {
                newState.edit.planOrder.delivery.internalExternalFiles = [
                    ...newState.edit.planOrder.delivery.internalExternalFiles,
                    assign({}, action.result)
                ];

                if (action.result.oldFileId) {
                    newState.edit.planOrder.delivery.internalExternalFiles = [
                        ...newState.edit.planOrder.delivery.internalExternalFiles.filter(
                            (x) => x.planOrderExternalFileId !== action.result.oldFileId
                        )
                    ];
                }
            }

            return newState;

        case types.ADD_PLAN_ORDER_STOREY_EXTERNAL_FILE_SUCCESS:
            newState = assign({}, state);
            let addIndex = newState.edit.planOrder.stories.findIndex(
                (x) => x.id === action.result.planOrderStoreyId
            );
            newState.edit.planOrder.stories[addIndex].externalFiles = [
                ...newState.edit.planOrder.stories[addIndex].externalFiles,
                assign({}, action.result)
            ];

            if (action.result.oldFileInfoId) {
                let deleteIndex = newState.edit.planOrder.stories.findIndex(
                    (x) => x.id === action.result.planOrderStoreyId
                );
                newState.edit.planOrder.stories[deleteIndex].externalFiles = [
                    ...newState.edit.planOrder.stories[deleteIndex].externalFiles.filter(
                        (x) => x.fileInfoId !== action.result.oldFileInfoId
                    )
                ];
            }

            if (
                newState.edit.planOrder.delivery &&
                newState.edit.planOrder.delivery.internalExternalFiles
            ) {
                newState.edit.planOrder.delivery.internalExternalFiles = [
                    ...newState.edit.planOrder.delivery.internalExternalFiles,
                    assign({}, action.result)
                ];

                if (action.result.oldFileReference) {
                    newState.edit.planOrder.delivery.internalExternalFiles = [
                        ...newState.edit.planOrder.delivery.internalExternalFiles.filter(
                            (x) => x.fileReference !== action.result.oldFileReference
                        )
                    ];
                }
            }

            return newState;

        case types.DELETE_PLAN_ORDER_EXTERNAL_DELIVERY_FILE_SUCCESS:
            newState = assign({}, state);

            let edf = newState.edit.planOrder.externalDeliveryFiles.filter(
                (x) => x.fileInfoId !== action.result.fileInfoId
            );
            newState.edit.planOrder.externalDeliveryFiles = edf;

            if (
                newState.edit.planOrder.delivery &&
                newState.edit.planOrder.delivery.externalDeliveryFiles
            ) {
                let dedf = newState.edit.planOrder.delivery.externalDeliveryFiles.filter(
                    (x) => x.fileReference !== action.result.fileReference
                );

                newState.edit.planOrder.delivery.externalDeliveryFiles = dedf;
            }

            return newState;

        case types.DELETE_PLAN_ORDER_INTERNAL_EXTERNAL_FILE_SUCCESS:
            newState = assign({}, state);
            newState.edit.planOrder.internalExternalFiles = [
                ...newState.edit.planOrder.internalExternalFiles.filter(
                    (x) => x.fileInfoId !== action.result.fileInfoId
                )
            ];

            if (
                newState.edit.planOrder.delivery &&
                newState.edit.planOrder.delivery.internalExternalFiles
            ) {
                newState.edit.planOrder.delivery.internalExternalFiles = [
                    ...newState.edit.planOrder.delivery.internalExternalFiles.filter(
                        (x) => x.fileReference !== action.result.fileReference
                    )
                ];
            }

            return newState;

        case types.DELETE_PLAN_ORDER_STOREY_EXTERNAL_FILE_SUCCESS:
            newState = assign({}, state);
            let deleteIndex = newState.edit.planOrder.stories.findIndex(
                (x) => x.id === action.result.planOrderStoreyId
            );
            newState.edit.planOrder.stories[deleteIndex].externalFiles = [
                ...newState.edit.planOrder.stories[deleteIndex].externalFiles.filter(
                    (x) => x.fileInfoId !== action.result.fileInfoId
                )
            ];

            if (
                newState.edit.planOrder.delivery &&
                newState.edit.planOrder.delivery.internalExternalFiles
            ) {
                newState.edit.planOrder.delivery.internalExternalFiles = [
                    ...newState.edit.planOrder.delivery.internalExternalFiles.filter(
                        (x) => x.fileReference !== action.result.fileReference
                    )
                ];
            }

            return newState;

        case types.ADD_PLAN_ORDER_STOREY_2D_FILE_SUCCESS:
            newState = assign({}, state);
            let indexStorey2D = newState.edit.planOrder.stories.findIndex(
                (x) => x.id === action.result.planOrderStoreyId
            );
            let storeyfor2D = newState.edit.planOrder.stories[indexStorey2D];
            let last2dId = null;

            if (storeyfor2D.file2D) {
                last2dId = storeyfor2D.file2D.id;
            }

            storeyfor2D.file2D = action.result.file;

            if (!storeyfor2D.files) {
                storeyfor2D.files = [];
            }

            storeyfor2D.files.push({
                id: action.result.file.id,
                planOrderStoreyId: storeyfor2D.id,
                warmStorageReference: action.result.file.fileReference,
                filename: storeyfor2D.file2D.filename,
                is2D: true,
                revisions: [],
                rolename: 'role/plan-editor',
                parentId: last2dId
            });

            return newState;

        case types.ADD_PLAN_ORDER_STOREY_3D_FILE_SUCCESS:
            newState = assign({}, state);
            let indexStorey3D = newState.edit.planOrder.stories.findIndex(
                (x) => x.id === action.result.planOrderStoreyId
            );

            let storeyfor3D = newState.edit.planOrder.stories[indexStorey3D];
            let last3dId = null;

            if (storeyfor3D.file2D) {
                last3dId = storeyfor3D.file2D.id;
            }

            storeyfor3D.file3D = action.result.file;

            if (!storeyfor3D.files) {
                storeyfor3D.files = [];
            }

            storeyfor3D.files.push({
                id: action.result.file.id,
                planOrderStoreyId: storeyfor3D.id,
                warmStorageReference: action.result.file.fileReference,
                filename: storeyfor3D.file3D.filename,
                is3D: true,
                revisions: [],
                rolename: 'role/plan-editor',
                parentId: last3dId
            });

            return newState;

        case types.APPROVE_PLAN_ORDER_SUCCESS:
            newState = assign({}, state);
            newState.edit.planOrder.status = action.result.status.name;
            newState.list = [...newState.list.filter((x) => x.id !== action.result.planOrderId)];
            return newState;

        case types.GENERATE_FILES_PLAN_ORDER_SUCCESS:
            newState = assign({}, state);
            if (action.result) {
                newState.edit.planOrder.delivery = assign({}, action.result);
            }
            return newState;

        case types.EDITOR_EDIT_PLAN_ANNOTATION_SUCCESS:
            newState = assign({}, state);
            newState.annotation = assign({}, action.result);
            return newState;

        case types.PLAN_EDITOR_UPDATE_PLAN_EDITOR_SUCCESS:
            newState = assign({}, state);
            if (action.result.dontRemoveFromList) {
                newState.list.forEach((x) => {
                    if (x.id === action.result.planOrderId) {
                        x.planEditorId = action.result.planEditorId;
                        x.planEditor = action.result.planEditor;
                    }
                });
            } else {
                newState.list = newState.list.filter((x) => x.id !== action.result.planOrderId);
            }
            return newState;

        case types.RESET_PLAN_EDITOR_ORDERS_LIST:
            newState = assign({}, state);
            newState.list = InitialState.list;
            return newState;

        case types.ADD_PLAN_EDITOR_STOREY_SUCCESS:
            newState = assign({}, state);
            newState.edit.planOrder.stories = newState.edit.planOrder.stories.concat(
                action.result.stories.map((x) => assign({}, x))
            );

            return newState;

        case types.UPDATE_EDITOR_PLAN_ORDER_STOREY_SORT_SUCCESS:
            newState = assign({}, state);
            let stories: any[] = newState.edit.planOrder.stories;
            action.result.forEach((item) => {
                let match = stories.find((x) => x.id === item.id);
                if (match) {
                    match.sort = item.sort;
                }
            });
            newState.stories = [...stories.sort((a, b) => a.sort - b.sort)];
            return newState;

        case types.DELETE_EDITOR_STOREY_SUCCESS:
            newState = assign({}, state);

            newState.edit.planOrder.stories = [
                ...newState.edit.planOrder.stories.filter(
                    (x: any) => x.id !== action.result.storeyId
                )
            ];

            if (newState.edit.planOrder.delivery) {
                newState.edit.planOrder.delivery = assign({}, action.result.deliveryFiles);
            }

            return newState;

        case types.UPDATE_EDITOR_PLAN_ORDER_SUCCESS:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    planOrder: {
                        ...state.edit.planOrder,
                        stories: state.edit.planOrder.stories.map((storey) => {
                            if (storey.id !== action.result.id) {
                                return storey;
                            }

                            return {
                                ...storey,
                                storeyId: action.result.storeyId,
                                customStoreyName: action.result.customStoreyName
                            };
                        })
                    }
                }
            };

        case types.EDITOR_DELETE_DELIVERY_FILE_SUCCESS:
            newState = assign({}, state);

            let d_edf = newState.edit.planOrder.externalDeliveryFiles.filter(
                (x: any) => x.fileReference !== action.result
            );
            newState.edit.planOrder.externalDeliveryFiles = d_edf;

            if (newState.edit.planOrder.delivery.stories) {
                newState.edit.planOrder.delivery.stories.forEach((storey) => {
                    if (storey.sketchUpPlan2Ds) {
                        storey.sketchUpPlan2Ds = storey.sketchUpPlan2Ds.filter(
                            (x: any) => x.fileReference !== action.result
                        );
                    }
                    if (storey.sketchUpPlan3Ds) {
                        storey.sketchUpPlan3Ds = storey.sketchUpPlan3Ds.filter(
                            (x: any) => x.fileReference !== action.result
                        );
                    }
                    if (storey.roomSketcherPlan2Ds) {
                        storey.roomSketcherPlan2Ds = storey.roomSketcherPlan2Ds.filter(
                            (x: any) => x.fileReference !== action.result
                        );
                    }
                    if (storey.roomSketcherPlan3Ds) {
                        storey.roomSketcherPlan3Ds = storey.roomSketcherPlan3Ds.filter(
                            (x: any) => x.fileReference !== action.result
                        );
                    }
                });
            }

            if (newState.edit.planOrder.delivery.externalDeliveryFiles) {
                let d_dedf = newState.edit.planOrder.delivery.externalDeliveryFiles.filter(
                    (x: any) => x.fileReference !== action.result
                );
                newState.edit.planOrder.delivery.externalDeliveryFiles = d_dedf;
            }

            return newState;

        default:
            return state;
    }
}
